import React, { useEffect } from "react";

// js
import "../assets/js/main.min.js";

//router
import { Redirect, Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

// css
import "../assets/css/main.min.css";
import "../assets/css/custom.css";

// component
import Navbar from "../component/navbar/Navbar";
import Topnav from "../component/navbar/Topnav";
import BannerTable from "../component/table/Banner";
import CoinPlanTable from "../component/table/CoinPlan";
import PurchaseCoinPlanHistoryTable from "../component/table/PurchaseCoinPlanHistory";
import VIPPlanTable from "../component/table/VIPPlan";
import PurchaseVIPPlanTable from "../component/table/PurchaseVipPlanHistory";
import GiftCategoryTable from "../component/table/GiftCategory";
import GiftTable from "../component/table/Gift";
import SongTable from "../component/table/Song";
import SongDialog from "../component/dialog/Song";
import GiftDialog from "../component/dialog/Gift/Add";
import HashtagTable from "../component/table/Hashtag";
import LevelTable from "../component/table/Level";
import LevelUpReward from "../component/table/LevelUpReward.js";
import UserTable from "../component/table/User";
import PostTable from "../component/table/Post";
import VideoTable from "../component/table/Video";
import UserDetail from "./UserDetail";
import UserHistory from "./UserHistory";
import PostDetail from "./PostDetail";
import VideoDetail from "./VideoDetail";
import Dashboard from "./Dashboard";
import Setting from "./Settings";
import ThemeTable from "../component/table/Theme.js";
import Advertisement from "../component/table/Advertisement";
import PendingComplainTable from "../component/table/PendingComplain";
import SolvedComplainTable from "../component/table/SolvedComplain";
import PendingRedeemTable from "../component/table/PendingRedeem";
import AcceptedRedeemTable from "../component/table/AcceptedRedeem";
import DeclineRedeemTable from "../component/table/DeclineRedeem";
import ReportedUserTable from "../component/table/ReportedUser";
import StickerTable from "../component/table/Sticker";
import Background from "../component/table/Background";

//loader
import Spinner from "./Spinner";
import Profile from "./Profile.js";
import Security from "./Security.js";
import TeenPattiHistory from "../component/table/gameHistory/TeenPattiHistory.js";
import Avatar from "../component/table/Avatar.js";
import admissionCar from "../component/table/AdmissionCar.js";
import CoinSeller from "../component/table/CoinSeller.js";
import CoinSellerHistory from "../component/table/CoinSellerHistory.js";
import DeactivationRequests from "./DeactivationRequests.js";
import SendReward from "./SendReward.js";
import RewardsHistory from "./RewardsHistory.js";
import SendGift from "./reward/SendGift.js";
import ReportedMoments from "../component/table/ReportedMoments.js";
import ReportedReels from "../component/table/ReportedReels.js";
import PartyChallenge from "./PartyChallenge.js";
import DiamondShop from "../component/table/DiamondShop.js";
import DiamondSellerShop from "../component/table/DiamondSellerShop.js";
import PaymentMethod from "../component/table/PaymentMethod.js";
import PartyRoom from "./PartyRoom.js";
import VideoLive from "./VideoLive.js";
import BannedUsersFromLive from "./BannedUsersFromLive.js";
import BannedUsersFromApp from "./BannedUsersFromApp.js";
import WhiteListedDevices from "./WhiteListedDevices.js";
import ArEffects from "./ArEffects.js";
import RechargeReward from "../component/table/RechargeReward.js";
import VipRewards from "../component/table/VipRewards.js";
import VibePass from "./VibePass.js";
import MakeUserVip from "./backendmgmt/MakeUserVip.js";
import VibeWheelHistory from "../component/table/gameHistory/vibeWheelHistory.js";
import DiamondRainHistory from "../component/table/gameHistory/DiamondRainHistory.js";
import BaishunHistory from "../component/table/gameHistory/BaishunHistory.js";
import DiasAppPurchase from "./backendmgmt/DiasAppPurchase.js";
import GameManagement from "./backendmgmt/GameManagement.js";
import GhostAccountManagement from "./backendmgmt/GhostAccountManagement.js";
import RestrictedAccountManagement from "./backendmgmt/RestrictedAccountManagement.js";
import DailyTaskRestrictionManagement from "./backendmgmt/DailyTaskRestrictionManagement.js";
import ReopenTreasureBox from "./backendmgmt/ReopenTreasureBox.js";
import IPManagement from "./backendmgmt/IPManagement.js";
import PurchaseTransactionsHistory from "../component/table/PurchaseTransactionsHistory.js";
import AdminManagement from "./AdminManagement.js";
import OutOfCountryUsers from "./OutOfCountryUsers.js";
import ActionsForApproval from "./ActionsForApproval.js";
import WeeklyStar from "./WeeklyStar.js";
import FamilyClanLevels from "./FamilyClanLevels.js";
import FamilyClans from "./FamilyClans.js";
import FamilyClanDetail from "./FamilyClanDetail.js";
import FamilyClanRanking from "./FamilyClanRanking.js";
import UserReferrals from "./UserReferrals.js";
import SvipUsers from "./SvipUsers.js";
import UserReferralDetail from "./UserReferralDetail.js";
import SuspiciousGiftPairs from "./backendmgmt/SuspiciousGiftPairs.js";
import UserGiftPairAnalysis from "./backendmgmt/UserGiftPairAnalysis.js";
import LivenessFaceReviews from "./backendmgmt/LivenessFaceReviews.js";
import LivenessAttempts from "./backendmgmt/LivenessAttempts.js";

const Admin = () => {
  const location = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    if (history.location.pathname === "/admin") {
      history.push("/admin/dashboard");
    } // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="page-container">
        <Navbar />
        <div className="page-content">
          <Topnav />
          <div className="main-wrapper">
            <Switch>
              <Route
                path={`${location.path}/dashboard`}
                exact
                component={Dashboard}
              />
              <Route
                path={`${location.path}/profile`}
                exact
                component={Profile}
              />
              <Route
                path={`${location.path}/security`}
                exact
                component={Security}
              />
              <Route
                path={`${location.path}/banner`}
                exact
                component={BannerTable}
              />
              <Route
                path={`${location.path}/diamondPlan`}
                exact
                component={CoinPlanTable}
              />
              <Route
                path={`${location.path}/diamondPlan/history`}
                exact
                component={PurchaseCoinPlanHistoryTable}
              />
              <Route
                path={`${location.path}/vipplan`}
                exact
                component={VIPPlanTable}
              />
              <Route
                path={`${location.path}/vipplan/history`}
                exact
                component={PurchaseVIPPlanTable}
              />
              <Route
                path={`${location.path}/purchaseTransactions`}
                exact
                component={PurchaseTransactionsHistory}
              />
              <Route
                path={`${location.path}/giftCategory`}
                exact
                component={GiftCategoryTable}
              />
              <Route
                path={`${location.path}/theme`}
                exact
                component={ThemeTable}
              />
              <Route
                path={`${location.path}/giftCategory/gift`}
                exact
                component={GiftTable}
              />
              <Route
                path={`${location.path}/giftCategory/gift/dialog`}
                exact
                component={GiftDialog}
              />
              <Route
                path={`${location.path}/gift`}
                exact
                component={GiftTable}
              />
              <Route
                path={`${location.path}/gift/dialog`}
                exact
                component={GiftDialog}
              />
              <Route
                path={`${location.path}/song`}
                exact
                component={SongTable}
              />
              <Route
                path={`${location.path}/song/dialog`}
                exact
                component={SongDialog}
              />
              <Route
                path={`${location.path}/hashtag`}
                exact
                component={HashtagTable}
              />
              <Route
                path={`${location.path}/level`}
                exact
                component={LevelTable}
              />
              <Route
                path={`${location.path}/familyClanLevels`}
                exact
                component={FamilyClanLevels}
              />
              <Route
                path={`${location.path}/familyClans`}
                exact
                component={FamilyClans}
              />
              <Route
                path={`${location.path}/familyClans/:id`}
                exact
                component={FamilyClanDetail}
              />
              <Route
                path={`${location.path}/familyClanRanking`}
                exact
                component={FamilyClanRanking}
              />
              <Route
                path={`${location.path}/levelUpRewards`}
                exact
                component={LevelUpReward}
              />
              <Route
                path={`${location.path}/rechargeRewards`}
                exact
                component={RechargeReward}
              />
              <Route
                path={`${location.path}/vipRewards`}
                exact
                component={VipRewards}
              />
              <Route
                path={`${location.path}/vibePass`}
                exact
                component={VibePass}
              />
              <Route
                path={`${location.path}/dailyTaskRewards`}
                exact
                render={() => <Redirect to={`${location.path}/vibePass`} />}
              />
              <Route
                path={`${location.path}/giftBoxLevels`}
                exact
                render={() => <Redirect to={`${location.path}/vibePass`} />}
              />
              <Route
                path={`${location.path}/user`}
                exact
                component={UserTable}
              />
              <Route
                path={`${location.path}/svipUsers`}
                exact
                component={SvipUsers}
              />
              <Route
                path={`${location.path}/userReferrals`}
                exact
                component={UserReferrals}
              />
              <Route
                path={`${location.path}/userReferrals/:userId`}
                exact
                component={UserReferralDetail}
              />
              <Route
                path={`${location.path}/whiteListedDevices`}
                exact
                component={WhiteListedDevices}
              />
              <Route
                path={`${location.path}/teenPattiHistory`}
                exact
                component={TeenPattiHistory}
              />
              <Route
                path={`${location.path}/vibeWheelHistory`}
                exact
                component={VibeWheelHistory}
              />
              <Route
                path={`${location.path}/diamondRainHistory`}
                exact
                component={DiamondRainHistory}
              />
              <Route
                path={`${location.path}/baishunHistory`}
                exact
                component={BaishunHistory}
              />
              <Route
                path={`${location.path}/user/detail`}
                exact
                component={UserDetail}
              />
              <Route
                path={`${location.path}/user/history`}
                exact
                component={UserHistory}
              />
              <Route
                path={`${location.path}/post`}
                exact
                component={PostTable}
              />
              <Route
                path={`${location.path}/post/detail`}
                exact
                component={PostDetail}
              />
              <Route
                path={`${location.path}/video`}
                exact
                component={VideoTable}
              />
              <Route
                path={`${location.path}/setting`}
                exact
                component={Setting}
              />
              <Route
                path={`${location.path}/video/detail`}
                exact
                component={VideoDetail}
              />
              <Route
                path={`${location.path}/reportedUser`}
                exact
                component={ReportedUserTable}
              />
              <Route
                path={`${location.path}/reportedMoments`}
                exact
                component={ReportedMoments}
              />
              <Route
                path={`${location.path}/reportedReels`}
                exact
                component={ReportedReels}
              />
              <Route
                path={`${location.path}/advertisement`}
                exact
                component={Advertisement}
              />
              <Route
                path={`${location.path}/pendingComplain`}
                exact
                component={PendingComplainTable}
              />
              <Route
                path={`${location.path}/arEffects`}
                exact
                component={ArEffects}
              />
              <Route
                path={`${location.path}/solvedComplain`}
                exact
                component={SolvedComplainTable}
              />
              <Route
                path={`${location.path}/pendingRedeem`}
                exact
                component={PendingRedeemTable}
              />
              <Route
                path={`${location.path}/diamondSeller`}
                exact
                component={CoinSeller}
              />
              <Route
                path={`${location.path}/diamondSellerShop`}
                exact
                component={DiamondSellerShop}
              />
              <Route
                path={`${location.path}/diamondSeller/history`}
                exact
                component={CoinSellerHistory}
              />

              <Route
                path={`${location.path}/acceptedRedeem`}
                exact
                component={AcceptedRedeemTable}
              />
              <Route
                path={`${location.path}/declineRedeem`}
                exact
                component={DeclineRedeemTable}
              />
              <Route
                path={`${location.path}/paymentMethod`}
                exact
                component={PaymentMethod}
              />
              <Route
                path={`${location.path}/sticker`}
                exact
                component={StickerTable}
              />
              <Route
                path={`${location.path}/admissionCar`}
                exact
                component={admissionCar}
              />

              <Route
                path={`${location.path}/avatarFrame`}
                exact
                component={Avatar}
              />

              <Route
                path={`${location.path}/background`}
                exact
                component={Background}
              />

              <Route
                path={`${location.path}/deactivationRequests`}
                exact
                component={DeactivationRequests}
              />

              <Route
                path={`${location.path}/sendReward`}
                exact
                component={SendReward}
              />

              <Route
                path={`${location.path}/sendGift`}
                exact
                component={SendGift}
              />

              <Route
                path={`${location.path}/actionsForApproval`}
                exact
                component={ActionsForApproval}
              />

              <Route
                path={`${location.path}/rewardsHistory`}
                exact
                component={RewardsHistory}
              />

              <Route
                path={`${location.path}/partyChallenge`}
                exact
                component={PartyChallenge}
              />
              <Route
                path={`${location.path}/backend-management/outOfCountryUsers`}
                exact
                component={OutOfCountryUsers}
              />

              <Route
                path={`${location.path}/diamondShop`}
                exact
                component={DiamondShop}
              />
              <Route
                path={`${location.path}/partyRoom`}
                exact
                component={PartyRoom}
              />
              <Route
                path={`${location.path}/videoLive`}
                exact
                component={VideoLive}
              />
              <Route
                path={`${location.path}/bannedUsersFromLive`}
                exact
                component={BannedUsersFromLive}
              />
              <Route
                path={`${location.path}/bannedUsersFromApp`}
                exact
                component={BannedUsersFromApp}
              />
              <Route
                path={`${location.path}/adminManagement`}
                exact
                component={AdminManagement}
              />
              <Route
                path={`${location.path}/backend-management/makeVIP`}
                exact
                component={MakeUserVip}
              />
              <Route
                path={`${location.path}/backend-management/diasAppPurchase`}
                exact
                component={DiasAppPurchase}
              />
              <Route
                path={`${location.path}/backend-management/gameSettings`}
                exact
                component={GameManagement}
              />
              <Route
                path={`${location.path}/backend-management/ghostAccounts`}
                exact
                component={GhostAccountManagement}
              />

              <Route
                path={`${location.path}/backend-management/restrictedAccounts`}
                exact
                component={RestrictedAccountManagement}
              />
              <Route
                path={`${location.path}/backend-management/dailyTaskRestrictions`}
                exact
                component={DailyTaskRestrictionManagement}
              />

              <Route
                path={`${location.path}/backend-management/suspiciousGiftPairs`}
                exact
                component={SuspiciousGiftPairs}
              />

              <Route
                path={`${location.path}/backend-management/livenessFaceReviews`}
                exact
                component={LivenessFaceReviews}
              />
              <Route
                path={`${location.path}/backend-management/livenessAttempts`}
                exact
                component={LivenessAttempts}
              />

              <Route
                path={`${location.path}/backend-management/userGiftPairAnalysis`}
                exact
                component={UserGiftPairAnalysis}
              />

              <Route
                path={`${location.path}/backend-management/reopenTreasureBox`}
                exact
                component={ReopenTreasureBox}
              />
              <Route
                path={`${location.path}/backend-management/ipManagement`}
                exact
                component={IPManagement}
              />
              <Route
                path={`${location.path}/weeklyStar`}
                exact
                component={WeeklyStar}
              />
            </Switch>
            <Spinner />
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
